import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SkeletonChildren from './SkeletonChildren';
import ClientProvider from './client';
export default createDemo(import.meta.url, SkeletonChildren, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/skeleton/demos/children/SkeletonChildren.tsx",
    "fileName": "SkeletonChildren.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Avatar from '@mui/material/Avatar';\nimport Grid from '@mui/material/Grid';\nimport Skeleton from '@mui/material/Skeleton';\n\nconst Image = styled('img')({\n  width: '100%',\n});\n\nfunction SkeletonChildrenDemo(props: { loading?: boolean }) {\n  const { loading = false } = props;\n\n  return (\n    <div>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ margin: 1 }}>\n          {loading ? (\n            <Skeleton variant=\"circular\">\n              <Avatar />\n            </Skeleton>\n          ) : (\n            <Avatar src=\"https://pbs.twimg.com/profile_images/877631054525472768/Xp5FAPD5_reasonably_small.jpg\" />\n          )}\n        </Box>\n        <Box sx={{ width: '100%' }}>\n          {loading ? (\n            <Skeleton width=\"100%\">\n              <Typography>.</Typography>\n            </Skeleton>\n          ) : (\n            <Typography>Ted</Typography>\n          )}\n        </Box>\n      </Box>\n      {loading ? (\n        <Skeleton variant=\"rectangular\" width=\"100%\">\n          <div style={{ paddingTop: '57%' }} />\n        </Skeleton>\n      ) : (\n        <Image\n          src=\"https://pi.tedcdn.com/r/talkstar-photos.s3.amazonaws.com/uploads/72bda89f-9bbf-4685-910a-2f151c4f3a8a/NicolaSturgeon_2019T-embed.jpg?w=512\"\n          alt=\"\"\n        />\n      )}\n    </div>\n  );\n}\n\nexport default function SkeletonChildren() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Grid container spacing={8}>\n      <Grid size=\"grow\">\n        <SkeletonChildrenDemo loading />\n      </Grid>\n      <Grid size=\"grow\">\n        <SkeletonChildrenDemo />\n      </Grid>\n    </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 62,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\nimport Avatar from '@mui/material/Avatar';\nimport Grid from '@mui/material/Grid';\nimport Skeleton from '@mui/material/Skeleton';\n\nconst Image = styled('img')({\n  width: '100%',\n});\n\nfunction SkeletonChildrenDemo(props: { loading?: boolean }) {\n  const { loading = false } = props;\n\n  return (\n    <div>\n      <Box sx={{ display: 'flex', alignItems: 'center' }}>\n        <Box sx={{ margin: 1 }}>\n          {loading ? (\n            <Skeleton variant=\"circular\">\n              <Avatar />\n            </Skeleton>\n          ) : (\n            <Avatar src=\"https://pbs.twimg.com/profile_images/877631054525472768/Xp5FAPD5_reasonably_small.jpg\" />\n          )}\n        </Box>\n        <Box sx={{ width: '100%' }}>\n          {loading ? (\n            <Skeleton width=\"100%\">\n              <Typography>.</Typography>\n            </Skeleton>\n          ) : (\n            <Typography>Ted</Typography>\n          )}\n        </Box>\n      </Box>\n      {loading ? (\n        <Skeleton variant=\"rectangular\" width=\"100%\">\n          <div style={{ paddingTop: '57%' }} />\n        </Skeleton>\n      ) : (\n        <Image\n          src=\"https://pi.tedcdn.com/r/talkstar-photos.s3.amazonaws.com/uploads/72bda89f-9bbf-4685-910a-2f151c4f3a8a/NicolaSturgeon_2019T-embed.jpg?w=512\"\n          alt=\"\"\n        />\n      )}\n    </div>\n  );\n}\n\nexport default function SkeletonChildren() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Grid container spacing={8}>\n      <Grid size=\"grow\">\n        <SkeletonChildrenDemo loading />\n      </Grid>\n      <Grid size=\"grow\">\n        <SkeletonChildrenDemo />\n      </Grid>\n    </Grid>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "container"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "8"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "grow",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "SkeletonChildrenDemo"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "grow",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 58
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "SkeletonChildrenDemo"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 59
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 60
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Grid"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 62,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/Typography",
      "@mui/material/Avatar",
      "@mui/material/Grid",
      "@mui/material/Skeleton"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
